import React from 'react';
import { Route, NavLink, Switch } from 'react-router-dom';
import { DICT_IGNORE_PATH } from '@/constants';

import './index.less';

export default function slideMenu(props) {
  const menusPaths = collectSubMenus(props.children);
  if (!menusPaths.length) return null;

  const { className = '' } = props;

  return (
    <div className={'slide-menu-wrap ' + className}>
      {menusPaths.map((item, index) => {
        return (
          <NavLink className="slide-menu-item" activeStyle={{ color: 'red' }} to={item.props.path} key={index}>
            {item.props.title}
          </NavLink>
        );
      })}
    </div>
  );
}

/**
 * 收集当前页面下的路由(<Route />)
 * 遇到的问题是children是children是一个Switch(原因是生成路由的时候加上的)，
 * 需要找Switch的子元素props.children
 * 一共会找两层：意味着即使children是Route但是其中混着
 * <Switch><Route /></Switch>这个Route也会被挑出来
 */
export function collectSubMenus(children) {
  children = React.Children.toArray(children);
  const res = [];

  children.forEach((item) => {
    if (item.type === Route) res.push(item);
    else if (item.type === Switch) {
      React.Children.toArray(item.props.children).forEach((item) => {
        res.push(item);
      });
    }
  });

  return res.filter((item) => {
    return (
      // 只有Route才能转换成链接
      item.type === Route &&
      // 同级路由下会有一些脏路由，例如*这种兜底路由需要过滤掉
      !item.props.hideInNav &&
      !DICT_IGNORE_PATH[item.props.relativePath] &&
      !DICT_IGNORE_PATH[item.props.path]
    );
  });
}
